import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ResumeService } from 'src/app/modules/dashboard/services/resume.service';
import { DataAlertProgresBarPriority } from '../../../interfaces/dash-alerts-interfaces';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'bar-priority-alert',
  templateUrl: './bar-priority-alert.component.html',
  styleUrls: ['./bar-priority-alert.component.scss'],
})
export class BarPriorityAlertComponent implements OnInit, AfterViewInit {
  constructor(private resumeService: ResumeService) {}
  barDataPriority: DataAlertProgresBarPriority[];
  total: number;
  displayedColumns: string[] = ['user', 'gai', 'count'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = (data, property) => {
      if (property === 'gai') {
        return data.alert?.gai || '';
      }
    };

    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  ngOnInit() {
    // this.getDataPriority();
    this.getDataStrikeByAlert();
  }
  get isEmpty() {
    return this.barDataPriority?.length == 0 ? true : false;
  }
  async getDataPriority() {
    await this.resumeService
      .getDataProgressPriorityAlert()
      .subscribe((res: any) => {
        this.barDataPriority = res.caseInfo;
        this.total = res.total;
      });
  }
  async getDataStrikeByAlert() {
    await this.resumeService.getDataStrikeByAlert().subscribe((res: any) => {
      this.barDataPriority = res.result;
      this.total = res.total;
      this.dataSource = new MatTableDataSource(res.result);
    });
  }
}
